import { useLocation } from 'react-router-dom'

export const useShouldMatchBrowserLanguage = (): boolean => {
    const { search = '' } = useLocation()

    const searchParams = new URLSearchParams(search)
    const matchBrowserLanguageParams = searchParams.get('matchBrowserLanguage')

    const shouldMatchBrowserLanguage = matchBrowserLanguageParams === 'true'

    return shouldMatchBrowserLanguage
}
